// extracted by mini-css-extract-plugin
export default {"codeInput":"ResetPassword_codeInput__E+OU+","loginBox":"ResetPassword_loginBox__q1ReO"};